(() => {
  if (window.kapiaV2Boot) return;
  window.kapiaV2Boot = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    const marker = document.querySelector('[data-kapia-v2]');
    if (!marker) return;
    if (!reduced) document.body.classList.add('kv-motion');
    const nav = document.querySelector('.kv-nav');
    const button = document.querySelector('.kv-menu-button');
    const menu = document.querySelector('.kv-menu');
    if (button && !button.dataset.ready) {
      button.dataset.ready = '1';
      let previousOverflow = '';
      const links = [...menu.querySelectorAll('a')];
      const close = (focus = false) => {
        menu.hidden = true; menu.classList.remove('is-open');
        button.setAttribute('aria-expanded','false');
        document.body.style.overflow = previousOverflow;
        if (focus) button.focus();
      };
      button.addEventListener('click',() => {
        if (!menu.hidden) { close(); return; }
        previousOverflow = document.body.style.overflow;
        menu.hidden = false; menu.classList.add('is-open');
        button.setAttribute('aria-expanded','true');
        document.body.style.overflow = 'hidden'; links[0].focus();
      });
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click',() => close()));
      document.addEventListener('keydown', e => {
        if (menu.hidden) return;
        if (e.key === 'Escape') close(true);
        if (e.key === 'Tab') {
          const focusable = [...nav.querySelectorAll('a,button'),...links].filter(x => x.offsetParent !== null);
          const i = focusable.indexOf(document.activeElement);
          if (e.shiftKey && i === 0) { e.preventDefault(); focusable.at(-1).focus(); }
          if (!e.shiftKey && i === focusable.length-1) { e.preventDefault(); focusable[0].focus(); }
        }
      });
    }
    if ('IntersectionObserver' in window && !reduced) {
      const observer = new IntersectionObserver(entries => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
      }), {threshold:.07,rootMargin:'0px 0px 32px 0px'});
      document.querySelectorAll('.kv-reveal:not([data-observed])').forEach(el => {el.dataset.observed='1';observer.observe(el);});
      document.querySelectorAll('[data-kv-words]:not([data-ready])').forEach(el => {
        el.dataset.ready='1';
        const words=[];
        [...el.childNodes].forEach(node => {
          if (node.nodeType !== Node.TEXT_NODE) return;
          const frag=document.createDocumentFragment();
          node.textContent.split(/(\s+)/).filter(Boolean).forEach(word => {
            if (/^\s+$/.test(word)) frag.append(document.createTextNode(word));
            else {const span=document.createElement('span');span.textContent=word;span.className='kv-word';frag.append(span);words.push(span);}
          });node.replaceWith(frag);
        });
        // One observer per threshold activates individual words in reading order.
        const levels=words.map((_,i)=>Math.min(.95,(i+1)/words.length));
        const wordObserver=new IntersectionObserver(entries => entries.forEach(entry => {
          const n=Math.round(entry.intersectionRatio*words.length);
          words.forEach((word,i)=>word.classList.toggle('is-visible',i<n));
        }),{threshold:levels,rootMargin:'0px 0px -25% 0px'});
        wordObserver.observe(el);
      });
    }
    document.querySelectorAll('[data-kv-world]:not([data-ready])').forEach(world => {
      if (typeof window.mountScrollWorld !== 'function') return;
      const config=JSON.parse(world.parentElement.querySelector('.kv-world-config').textContent);
      if (config.sections.some(s=>s.clip||s.clipMobile)) world.classList.add('kv-has-film');
      if (matchMedia('(max-width:860px), (hover:none) and (pointer:coarse)').matches) {
        config.sections=config.sections.map(s=>({...s,clip:s.clipMobile||null,scroll:.9}));
      }
      world.dataset.ready='1'; window.mountScrollWorld(world,config);
    });
    document.querySelectorAll('[data-kv-shop]:not([data-ready])').forEach(shop => {
      shop.dataset.ready='1';
      const radios=[...shop.querySelectorAll('input[name="kv-pack"]')];
      function select(radio) {
        const d=radio.dataset;
        for (const key of ['price','unit','label','detail','offer','gift','saving']) {
          shop.querySelectorAll('[data-kv-'+key+']').forEach(el=>el.textContent=d[key]);
        }
        shop.querySelector('.kv-saving').hidden=!d.saving;
        shop.querySelector('[data-kv-buy]').href=d.link;
        shop.querySelector('[data-kv-buy]').setAttribute('aria-label','Comprar '+radio.value+(radio.value==='1'?' frasco':' frascos')+' de Antiox por '+d.price);
        shop.querySelector('.kv-bottles').dataset.quantity=radio.value;
      }
      radios.forEach(radio=>radio.addEventListener('change',()=>select(radio)));
      select(radios.find(r=>r.checked));
    });
    document.querySelectorAll('.kv a[href^="#"]:not([data-anchor-ready])').forEach(a => {
      a.dataset.anchorReady='1';
      a.addEventListener('click', e=>{
        const target=document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();target.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
        history.replaceState(null,'',a.getAttribute('href'));
      });
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.addEventListener('load',init,{once:true});
  document.addEventListener('shopify:section:load',init);
})();
